import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade, IconButton, Tooltip } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";

import CustomModal from "../../common/CustomModal";
import CustomTableV2 from "../../common/CustomTableV2";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";
import PromptDetails from "./components/PromptDetails";
import NewPromptDetails from "./components/NewPromptDetails";

import { GetPrompts, GetSystemPrompts } from "../../redux/prompt/actions";
import { GetAllIndiPrograms } from "../../redux/program/actions";

import "./style.css";

function Prompt(props) {
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [selectedPrompt, setSelectedPrompt] = useState(null);

    useEffect(() => {
        props.GetSystemPrompts();
        props.GetAllIndiPrograms();
    }, []);

    useEffect(() => {

        setSelectedPrompt(
            props.Prompt?.list?.find(prompt => prompt?.id === selectedPrompt?.id)
        )

    }, [props.Prompt?.list]);


    return (
        <div className="main-container" id="indi-ai-prompt">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="AI Prompts"
                        description=""
                        store={props.Prompt}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Name" },
                                { title: "Type" },
                                { title: "" },
                            ],
                            body: (prompt, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{prompt?.name?.toUpperCase()}</h5></td>
                                        <td><h5>{prompt?.type?.toUpperCase()}</h5></td>
                                        <td><ArrowForwardIosIcon id="view-arrow" onClick={async () => {
                                            setSelectedPrompt(prompt);
                                            setShowModal(true);
                                        }} /></td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetPrompts(page, count, filter, sort);
                            },
                            add: () => {
                                setShowModal2(true);
                                // setShowModal(true);
                                setSelectedPrompt(null);
                            },
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"Prompt Details"}>
                <PromptDetails promptValues={selectedPrompt ? {
                    ...selectedPrompt,
                    properties: selectedPrompt?.props ? JSON.parse(selectedPrompt?.props) : null,
                    systemPrompt: selectedPrompt?.system_prompt,
                } : null} />
            </CustomSliderModalV2>

            <CustomSliderModalV2 show={showModal2} setShow={setShowModal2} title={"Prompt Details"}>
                <NewPromptDetails exit={() => { setShowModal2(false) }} />
            </CustomSliderModalV2>


            {/* <CustomModal
                size="l"
                toggle={setShowModal2}
                show={showModal2}
                title="Prompt Details"
                body={(
                    <NewPromptDetails exit={() => { setShowModal2(false) }} />
                )}
            /> */}
        </div >
    );
}

const mapStateToProps = (state) => ({
    Prompt: state.Prompt,
    Program: state.Program,
})

export default connect(mapStateToProps, {
    GetPrompts,
    GetSystemPrompts,
    GetAllIndiPrograms,
})(Prompt);
